{
  "audit_trail": {
    "button": {
      "text": "Piste d'audit"
    },
    "modal": {
      "header": "Piste d'audit"
    },
    "loading": {
      "aria_label": "chargement des pistes d'audit"
    },
    "table": {
      "current": "Actuel"
    },
    "details": {
      "show_details_aria_label": "afficher les détails"
    }
  }
}
